<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.procedimento"
                    :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                    :search-fields="fields.autocompletes.procedimento"
                    :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                    :validations="validations.procedimento"
                    label="Procedimento"
                    v-model="model.procedimento"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-radio-group v-model="model.searchByApelido">
                                <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input-autocomplete>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, object, formats } from '@/mixins'

export default {
    computed: {
        autocompletesRequestParams() {

            return {
                procedimento: {
                    queryString: {
                        cbo: this.data.additionals.cbosPermitidos,
                        only_with_cbo: true,
                        search_by_apelido: this.model.searchByApelido,
                    }
                }
            }
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                procedimento: { required: true }
            }
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        model: {
            procedimento: null,
            searchByApelido: false,
        },
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.isDuplicated()) {

                        this.showValidationNotification('Este procedimento já foi incluído.')

                        return
                    }

                    this.data.model.servicosEnfermagem.push(this.clone(this.model))

                    this.$emit('save', this.clone(this.model))
                })
        },
        isDuplicated() {

            return this.data.model.servicosEnfermagem
                .find(s => s.procedimento.codigo === this.model.procedimento.codigo)
        }
    },
    mixins: [repository, object, formats],
    props: {
        data: { type: Object, required: true },
    },
}
</script>
